import * as React from 'react';

const CheckmarkShieldFilled64 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 64 64", width: 64, height: 64, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m31.993 5.333-21.34 8v18.67c0 18.67 21.34 26.67 21.34 26.67s21.34-8 21.34-26.67v-18.67l-21.34-8Zm-2.62 33.1-9.03-9.03 2.12-2.12 6.91 6.91 12.23-12.23 2.12 2.12-14.35 14.35Z"
  }
));
CheckmarkShieldFilled64.Size = 64;
CheckmarkShieldFilled64.Title = "CheckmarkShieldFilled";

export { CheckmarkShieldFilled64 as default };
